export const LANGUAGE_OPTIONS = [
	{ code: 'en', label: 'English' },
	{ code: 'hi', label: 'हिन्दी' },
	{ code: 'bn', label: 'বাংলা' },
	{ code: 'ta', label: 'தமிழ்' },
	{ code: 'te', label: 'తెలుగు' },
	{ code: 'kn', label: 'ಕನ್ನಡ' },
	{ code: 'or', label: 'ଓଡ଼ିଆ' },
	{ code: 'sd', label: 'सिंधी' },
	{ code: 'mai', label: 'मैथिली' },
	{ code: 'brx', label: 'बोडो' },
	{ code: 'ma', label: 'मराठी' },
	{ code: 'sa', label: 'संस्कृतम्' },
	{ code: 'ne', label: 'नेपाली' },
	{ code: 'as', label: 'অসমীয়া' },
	{ code: 'gu', label: 'ગુજરાતી' },
	{ code: 'doi', label: 'डोगरी' },
	{ code: 'ur', label: 'اردو' },
	{ code: 'kok', label: 'कोंकणी' },
	{ code: 'ml', label: 'മലയാളം' },
	{ code: 'mni', label: 'ꯃꯤꯇꯩ', altPart: { lang: 'en', text: '(Meitei)' } },
	{ code: 'pa', label: 'ਪੰਜਾਬੀ' },
	{ code: 'ks', label: 'کٲشُر' },
];
